<!-- start: ASSESSMENT PATIENT VIEW DETAIL -->
<app-assessment-patient-view-detail></app-assessment-patient-view-detail>
<!-- end: ASSESSMENT PATIENT VIEW DETAIL -->

<!-- start: ASSESSMENT WIZARD -->
<app-assessment-wizard *ngIf="assessmentHeader.wizardActiveIndex !== undefined" [activeIndex]="assessmentHeader.wizardActiveIndex"></app-assessment-wizard>
<!-- end: ASSESSMENT WIZARD -->